import { selectLocalPeer, useHMSStore } from "@100mslive/react-sdk";

export const useHMSLocalParticipant = () => useHMSStore(selectLocalPeer);
